import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const WirelessLanControllerNew = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="currentColor"
        >
          <g clip-path="url(#clip0_15478_26683)">
            <rect
              x="1.97876"
              y="4.56146"
              width="18.1128"
              height="10.8745"
              rx="0.875545"
              fill="url(#paint0_linear_15478_26683)"
            />
            <rect
              x="1.97876"
              y="4.56146"
              width="18.1128"
              height="10.8745"
              rx="0.875545"
              fill="url(#paint1_linear_15478_26683)"
              fill-opacity="0.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.146 8.01984H9.146V12.0614H8.31068V13.0198H4.98193V12.0614H4.146V8.01984Z"
              fill="#8CBE62"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.146 8.01984H9.146V12.0614H8.31068V13.0198H4.98193V12.0614H4.146V8.01984Z"
              fill="url(#paint2_linear_15478_26683)"
              fill-opacity="0.2"
            />
            <path
              d="M9.146 8.01984H9.30552C9.30552 7.93173 9.2341 7.86031 9.146 7.86031V8.01984ZM4.146 8.01984V7.86031C4.05789 7.86031 3.98647 7.93173 3.98647 8.01984H4.146ZM9.146 12.0614V12.221C9.2341 12.221 9.30552 12.1495 9.30552 12.0614H9.146ZM8.31068 12.0614V11.9019C8.22258 11.9019 8.15116 11.9733 8.15116 12.0614H8.31068ZM8.31068 13.0198V13.1793C8.39879 13.1793 8.47021 13.1079 8.47021 13.0198H8.31068ZM4.98193 13.0198H4.82241C4.82241 13.1079 4.89383 13.1793 4.98193 13.1793V13.0198ZM4.98193 12.0614H5.14146C5.14146 11.9733 5.07004 11.9019 4.98193 11.9019V12.0614ZM4.146 12.0614H3.98647C3.98647 12.1495 4.05789 12.221 4.146 12.221V12.0614ZM9.146 7.86031H4.146V8.17936H9.146V7.86031ZM9.30552 12.0614V8.01984H8.98647V12.0614H9.30552ZM8.31068 12.221H9.146V11.9019H8.31068V12.221ZM8.47021 13.0198V12.0614H8.15116V13.0198H8.47021ZM4.98193 13.1793H8.31068V12.8602H4.98193V13.1793ZM4.82241 12.0614V13.0198H5.14146V12.0614H4.82241ZM4.146 12.221H4.98193V11.9019H4.146V12.221ZM3.98647 8.01984V12.0614H4.30552V8.01984H3.98647Z"
              fill="#B3E48A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.7808 8.0199H17.7808V12.0615H16.9455V13.0196H13.6167V12.0615H12.7808V8.0199Z"
              fill="#151515"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.7808 8.0199H17.7808V12.0615H16.9455V13.0196H13.6167V12.0615H12.7808V8.0199Z"
              fill="url(#paint3_linear_15478_26683)"
              fill-opacity="0.4"
            />
            <path
              d="M17.7808 8.0199H17.9403C17.9403 7.93179 17.8689 7.86037 17.7808 7.86037V8.0199ZM12.7808 8.0199V7.86037C12.6927 7.86037 12.6212 7.93179 12.6212 8.0199H12.7808ZM17.7808 12.0615V12.221C17.8689 12.221 17.9403 12.1496 17.9403 12.0615H17.7808ZM16.9455 12.0615V11.902C16.8574 11.902 16.786 11.9734 16.786 12.0615H16.9455ZM16.9455 13.0196V13.1791C17.0336 13.1791 17.105 13.1077 17.105 13.0196H16.9455ZM13.6167 13.0196H13.4572C13.4572 13.1077 13.5286 13.1791 13.6167 13.1791V13.0196ZM13.6167 12.0615H13.7763C13.7763 11.9734 13.7049 11.902 13.6167 11.902V12.0615ZM12.7808 12.0615H12.6212C12.6212 12.1496 12.6927 12.221 12.7808 12.221V12.0615ZM17.7808 7.86037H12.7808V8.17942H17.7808V7.86037ZM17.9403 12.0615V8.0199H17.6212V12.0615H17.9403ZM16.9455 12.221H17.7808V11.902H16.9455V12.221ZM17.105 13.0196V12.0615H16.786V13.0196H17.105ZM13.6167 13.1791H16.9455V12.8601H13.6167V13.1791ZM13.4572 12.0615V13.0196H13.7763V12.0615H13.4572ZM12.7808 12.221H13.6167V11.902H12.7808V12.221ZM12.6212 8.0199V12.0615H12.9403V8.0199H12.6212Z"
              fill="#949494"
            />
            <circle cx="12.1509" cy="5.8378" r="0.68851" fill="#8CBE62" />
            <circle cx="9.76419" cy="5.8378" r="0.68851" fill="#F02B1E" />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_15478_26683"
              x1="11.0352"
              y1="4.56146"
              x2="11.0352"
              y2="15.627"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#564365" />
              <stop offset="0.150552" stop-color="#685974" />
              <stop offset="0.64" stop-color="#645074" />
              <stop offset="1" stop-color="#291935" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_15478_26683"
              x1="1.97876"
              y1="9.99869"
              x2="19.7935"
              y2="9.99869"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.100213" stop-opacity="0" />
              <stop offset="0.876586" stop-opacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_15478_26683"
              x1="6.61683"
              y1="8.19293"
              x2="6.59624"
              y2="12.8709"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.119491" stop-color="#8A8A8A" />
              <stop offset="0.882669" stop-color="#626262" />
              <stop offset="1" stop-color="#2E2D2D" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_15478_26683"
              x1="12.9303"
              y1="10.4467"
              x2="17.6975"
              y2="10.4254"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop
                offset="0.103943"
                stop-color="#555555"
                stop-opacity="0.917116"
              />
              <stop
                offset="0.858314"
                stop-color="#535353"
                stop-opacity="0.0974099"
              />
              <stop offset="1" />
            </linearGradient>
            <clipPath id="clip0_15478_26683">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.957275 0.149231)"
              />
            </clipPath>
          </defs>
        </SVGIconRender>
  );
};

export default WirelessLanControllerNew;
